import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';

export const StyledIconButton = styled.button<{
  size: 'small' | 'medium' | 'large';
  variant: 'primary' | 'secondary' | 'tertiary';
  disabled?: boolean;
  circular?: boolean;
  noBorder?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (hover: hover) {
    &:hover {
      cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
      background-color: ${(props) => {
        if (props.variant === 'primary' && !props.disabled) {
          return props.theme.atlas.semantic.color.action.primary.hover;
        }
        return props.theme.atlas.semantic.color.action.secondary.hoverFill;
      }};
    }
  }
  border-radius: ${(props) => (props.circular ? '50%' : '3px')};
  border: ${(props) => {
    if (props.disabled) {
      return `1px solid ${props.theme.atlas.semantic.color.action.primary.disabled}`;
    }
    if (props.noBorder) {
      return 'none';
    }
    switch (props.variant) {
      case 'secondary':
        return `1px solid ${props.theme.atlas.semantic.color.outline.default}`;
      case 'tertiary':
        return `1px solid ${props.theme.atlas.semantic.color.surface.default}`;
      default:
        return `1px solid ${props.theme.atlas.semantic.color.action.primary.default}`;
    }
  }};
  width: ${(props) => {
    switch (props.size) {
      case 'small':
        return '26px';
      case 'medium':
        return '38px';
      case 'large':
        return '48px';
    }
  }};
  height: ${(props) => {
    switch (props.size) {
      case 'small':
        return '26px';
      case 'medium':
        return '38px';
      case 'large':
        return '48px';
    }
  }};
  background-color: ${(props) => {
    if (props.disabled) {
      return props.theme.atlas.semantic.color.action.primary.disabled;
    }
    switch (props.variant) {
      case 'secondary':
        return props.theme.atlas.semantic.color.surface.default;
      case 'tertiary':
        return props.theme.atlas.semantic.color.surface.default;
      default:
        return props.theme.atlas.semantic.color.action.primary.default;
    }
  }};
`;

export const getIconColor = (
  variant: 'primary' | 'secondary' | 'tertiary',
  disabled?: boolean,
  theme?: DefaultTheme,
) => {
  if (disabled) {
    return theme?.atlas.semantic.color.type.disabled ?? 'transparent';
  }
  switch (variant) {
    case 'primary':
      return theme?.atlas.semantic.color.action.primary.onPrimary ?? '#fff';
    case 'secondary':
      return theme?.atlas.semantic.color.type.default ?? 'inherit';
    case 'tertiary':
      return theme?.atlas.semantic.color.type.default ?? 'inherit';
    default:
      return theme?.atlas.semantic.color.action.primary.onPrimary ?? '#fff';
  }
};

export const getIconSize = (size: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small':
      return '18px';
    case 'medium':
      return '20px';
    case 'large':
      return '24px';
    default:
      return '20px';
  }
};
